$(window).scroll(function(){
  var sticky = $('.dawn .header'),
      scroll = $(window).scrollTop();
  if (scroll >= 20){
    sticky.addClass('sticky');
    $('.back-to-top').removeClass('d-none');
    $('.header__inline-menu li').first().addClass('d-block');
  } 
  else {
    sticky.removeClass('sticky');
    $('.back-to-top').addClass('d-none');
    $('.header__inline-menu li').first().removeClass('d-block');
  }
});
$(document).on('click','.search-modal-header .modal__close-button',function () {
   $('.search-modal .search-modal__content').removeClass('show');
  setTimeout(function() {
      $('.search-modal').addClass('d-none');
    },50);
});
$(document).on('click','.back-to-top',function () {
  $('html, body').animate({scrollTop:0}, 'slow');
});
  
$(document).on('click','#search',function () {
    $('.search-modal').removeClass('d-none');
  setTimeout(function() {
    $('.search-modal .search-modal__content').addClass('show');
  },50);
});
$(document).on({
    mouseenter: function () {
        let self = $(this);
        self.parent().addClass('hover');
    },
    mouseleave: function () {
        let self = $(this);
        self.parent().removeClass('hover');
    }
}, ".img > a");
$(document).on({
    mouseenter: function () {
        let self = $(this);
        self.find('header-menu > details').attr('open',true);
    },
    mouseleave: function () {
        let self = $(this);
        self.find('header-menu > details').removeAttr('open');

    }
}, "ul.list-menu.list-menu--inline>li");
$(document).on('change', '#tags', function () {
    let self = $(this);
    let selectedEl = self.find('option.selected');
    let url = '';
    url += shopUrl + self.attr('data-baseurl');
    if (selectedEl.length != 0) {
        url = url.replace(selectedEl.val(), '');
    }else{
        url += '/';
    }
    url += self.val();
   window.location.href = url;
});
$(document).on('change', '#SortBy', function () {
    let self = $(this);
    url = window.location.href.split('?')[0] + '?sort_by=' + self.val();
    window.location.href = url;
});
var bReq = false;
function ScrollExecute() {
    if ($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
        if (bReq) {
            return;
        }
        var aUrl = window.location.href.split('/');
        scrollNode = $('a#more');
        scrollURL = scrollNode.attr("href");
        changeNode = scrollNode;
        pageNumber = scrollNode.attr("href");
        pagesEnd = $('.pagesEnd').text();
        pagesEnd = parseInt(pagesEnd);
        pageNumber = parseInt(pageNumber.slice(-1));
        if (pagesEnd >= pageNumber) {
            if (scrollNode.length > 0) {
                bReq = true;
                $('#loader').removeClass('hidden');
                $.ajax({
                    type: 'GET',
                    url: scrollURL,
                    success: function (data) {
                        // remove loading feedback
                        var filteredData = $(data).find("#product-grid").html();  // change as per templete #product-grid
                        $('#product-grid').append(filteredData);
                        pageNumber++;
                        changeNode.attr("href", "/collections/" + aUrl[aUrl.length - 1] + "/?page=" + pageNumber.toString());
                        $('#loader').addClass('hidden');
                        bReq = false;
                    },
                    dataType: "html"
                });
            }
        }
    }
}
  $(window).scroll(function (e) {
                      if ($(window).scrollTop() >= ($(document).height() - $(window).height()) - 850) {
                        ScrollExecute();
                    }
                });